import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question:
      "How TekRevol is a considerable option as an app development company in Florida?",
    answer: `<p>TekRevol stands out in Florida's app development market, providing progressive solutions. Our global track record and ground-breaking approach showcase our reliability. Utilizing premium tech and intuitive interfaces, we create seamless user experiences. Our AI-driven automation transforms business operations effectively.</p>`,
  },
  {
    question:
      "How do you ensure that the mobile apps developed for Florida businesses comply with local regulations and customer preferences?",
    answer: `<p>We prioritize local compliance and user preferences. Our team conducts thorough market research specific to Florida, ensuring our apps align with local regulations and cater to the preferences of the diverse Florida audience. We also engage in regular feedback sessions with our clients to refine our solutions further.</p>`,
  },
  {
    question: "What type of app is most profitable in Florida?",
    answer: `<p>App profitability hinges on strategy and objectives. With the gaming industry booming, businesses invest in gaming apps for maximum returns. TekRevol specializes in game app development, crafting stunning games with premium features and aligning with current gaming trends.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
